<template>
  <div id="home">
    <el-container>
      <el-aside>
        <!-- <img
          :src="logo"
          style="
            position: absolute;
            left: 0rem;
            z-index: 188;
            width: 225px;
            height: 55px;
          "
        />
          <el-menu
            class="el-menu-vertical-demo"
            :default-active="defaultActive"
            router
            @open="handleOpen"
            @select="handleClose"
            style="margin-top: 4rem"
          >
            <el-collapse accordion v-model="collapseactiveName">
              <el-collapse-item v-for="(item, i) in navList" :key="i"  :name="i">
                <template slot="title">
                  <i :class="item.icon"></i>{{ item.caidan }}
                </template>
                <el-menu-item
                  @click="clickmenu(item)"
                  v-for="(item, index) in navList[i].xiala"
                  :key="index"
                  :index="item.name"
                >
                  {{ item.navItem }}
                </el-menu-item>
              </el-collapse-item>
            </el-collapse>
          </el-menu> -->
          <Menu @menuItem="menuItemChild" @closeMenu="closeMenus" :activeIndexs="activeIndexs" :secondIndexs="secondIndexs" :menuItemData="menuItemData" :editableTabs="editableTabs"></Menu>
      </el-aside>
      <el-container>
        <el-header style="background-color: #e9eef3;">
          <div class="container">
            <div style="display: flex;align-items: center;cursor: pointer;">
            <el-breadcrumb separator="/">
  <el-breadcrumb-item v-for="(item,index) in breadcrumbList" :key="index" :to="{ path: item.name }">
    <span @click="homePage(item)"><i class="el-icon-s-home" v-if="item.caidan == '首页'"></i>{{  item.caidan }}</span>
  </el-breadcrumb-item>
</el-breadcrumb>
          </div>
          <div
            id="conter"
            style="font-weight: 900; font-size: 2rem; margin: auto"
          >
            <!-- 供应链大数据&nbsp;&nbsp;&nbsp;服务行业&nbsp;&nbsp;整合产业资源 -->
            {{ headline }}
            <!-- 面包屑 -->
          </div>
          <div style="display: flex;align-items: center;font-size: 15px;margin-right: 20px;cursor: pointer;" @click="goBackToMall()">
            返回商城
          </div>
          <div style="display: flex;align-items: center;justify-content: center;">
            <el-dropdown>
                <span class="el-dropdown-link" style="margin-left: 20px">
                  <el-avatar
                    src="	https://ziyichain.cn/statics/uploadfiles/up-620240424150439.jpg"
                  >
                  </el-avatar>
                </span>
                <el-dropdown-menu slot="dropdown">
                </el-dropdown-menu>
           </el-dropdown>
          <el-dropdown trigger="click" style="display: flex;align-items: center;">
     <div>
      <div
            v-for="(item, index) in PIMS"
            :key="index"
            style="
              display: flex;
              align-items: center;
              margin-right: 10px;
              margin-left: 10px;
            "
          >
          <div style="  display: flex;align-items: center;cursor: pointer;">
            <p style="line-height: normal">{{ item.company }}</p>
            <i class="el-icon-caret-bottom" style="font-size: 20px;margin-left: 10px;"></i>
          </div>
          </div>
     </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item><span @click="personal" style="display: inline-block;"><i class="el-icon-user"></i>个人信息</span></el-dropdown-item>
        <el-dropdown-item><span @click="changePassword" style="display: inline-block;"><i class="el-icon-edit-outline"></i>修改密码</span></el-dropdown-item>
        <el-dropdown-item><span @click="helpCenter" style="display: inline-block;"><i class="el-icon-question"></i>帮助中心</span></el-dropdown-item>
        <el-dropdown-item><span @click="logOut" style="display: inline-block;"><i class="el-icon-switch-button"></i>退出登录</span></el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
          </div>
          </div>
        </el-header>
        <div class="tabsBox">
          <!-- 动态增加标签 -->
          <div class="tabsContent">
            <!-- <div v-if="editableTabs.length == 0">
              欢迎加入孜益供应链特钢平台，
            </div> -->
              <el-tabs v-model="editableTabsValue" type="card" closable  @tab-remove="removeTab" @tab-click="handleClick" class="tabs">
          <el-tab-pane
            v-for="(item) in editableTabs"
            :key="item.name"
            :label="item.title"
            :name="item.name"
          >
          <span slot="label">{{ item.title }}</span>
          </el-tab-pane>
        </el-tabs>
        <div class="moreTbn" v-if="editableTabs.length> 0">
          <el-dropdown trigger="click">
      <span class="el-dropdown-link">
        <i class="el-icon-d-arrow-right"></i>
      </span>
      <el-dropdown-menu slot="dropdown" >
        <el-dropdown-item icon="el-icon-circle-close" ><span @click="close">关闭全部标签</span></el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
        </div>
        </div>
        </div>
        <el-main >
          <div
            v-if="defaultActive === 'home'"
            style=" margin: auto;padding: 20px;background: #fff;"
          >
            <!-- <img
              :src="homebg"
              style="width: 100%; max-width: 100%; height: 110%"
            /> -->
            <dashboard></dashboard>
            <!-- <qualificationApplication></qualificationApplication> -->
          </div>

          <!-- <keep-alive> -->
         <div style="background-color: #fff;padding: 20px 20px 0px 20px;"  v-if="defaultActive != 'home'">
          <router-view style="padding: 0rem 0rem" ref="pagefeed"></router-view>
         </div>
          <!-- </keep-alive> -->
        </el-main>
        <!-- <el-footer style="z-index: 99999; padding-top: 20px">
          <strong>Copyright © 2020-2023</strong>

          <a href="https://beian.miit.gov.cn/" target="view_window"
            >沪ICP备2023021369号-1
          </a>
          <i
            class="el-icon-office-building"
            style="color: black; margin-right: 0px"
          ></i
          >上海市青浦区徐泾镇徐乐路333弄9号1419室
          <i class="el-icon-phone" style="color: black; margin-right: 0px"></i>
          021-56998880
          <div
            style="
              float: right !important;
              color: #606266;
              padding-top: 0.25rem;
            "
          >
            <b>版本：</b> {{ edition }}
          </div>
        </el-footer> -->
      </el-container>
    </el-container>

  </div>
</template>

<script>
import {
  UserPage,
  userdata,
  allocation,
  edition,
  messageshow,
  companyid,
  userlevelpages
} from "../../static/API/API.js";
import Utils from "../js/util.js";
import Menu from "../components/menu.vue";
import dashboard from "../views/dashboard.vue";
import qualificationApplication from "../views/qualificationApplication.vue";

export default {
  name: "home",
  components:{Menu,dashboard,qualificationApplication},
  data() {
    return {
      edition: edition,
      defaultActive: "1",
      Version: "edition",
      navList: [],
      PIMS: [],
      //logo
      logo: "",
      //首页图片
      homebg: "",
      //标题
      headline: "",
      //系统人员
      activeName: [],
      // 信息数量
      NUM: 0,
      breadcrumbList:[{caidan:'首页',name:'/home'}],
      editableTabsValue: '1',
      editableTabs: [],
      tabIndex: 1,
      loading: true,
      collapseactiveName:null,
      secondIndexs: null,
      activeIndexs: null,
      menuItemData:''
    };
  },
  methods: {
    menuItemChild(e,index) {
      if(index == 1){
        this.editableTabs = [],
       sessionStorage.removeItem('editableTabs');
      }
      this.breadcrumbList = [{caidan:'首页',name:'/home'}]
      this.navList.map(item=>{
        item.child && item.child.map(val=>{
          if(e.name === val.name){
            if(item.name != '快捷导航'){
              this.breadcrumbList.push({caidan:item.name,name:e.page})
            }
          }
        })
      })
      this.breadcrumbList.push({caidan:e.name,name:e.page})
      if (e.name == "小程序数据") {
        let url = "https://wedata.weixin.qq.com/mp2/basic-data/core-data";
        window.open(url, "_blank ");
      }else{
        this.$router.push(e.page,()=>{}, ()=>{})
      }
      // 动态增加标签
      let res = this.editableTabs && this.editableTabs.filter((item) => {
        return item.title == e.name;
      });
      if(res && res.length > 0){
        this.$router.push(res[0].url,()=>{}, ()=>{})
        this.editableTabsValue = res[0].name;
      }else{
      let newTabName = ++ this.tabIndex + '';
        this.editableTabs.unshift({
          title: e.name,
          name: newTabName,
          url: e.page
      });
      this.editableTabs = this.editableTabs.slice(0,4)
      this.editableTabsValue = newTabName;
      sessionStorage.setItem("newTabName",JSON.stringify(newTabName));
      }

      sessionStorage.setItem("editableTabs",JSON.stringify(this.editableTabs));
      if(e.name == '退出系统'){
        this.close()
      }
    },
    homePage(item){
      if(item.caidan == '首页'){
        this.close()
      }
    },
    goBackToMall(){
  if (window.location.hostname == 'b.ziyichain.cn') {
    window.open('https://shop.ziyichain.cn/', '_blank');
  } else {
    window.open('https://s.ziyichain.cn/', '_blank');
  }
},
    closeMenus(item){
      // this.editableTabs.push({
      //     title: item.name,
      //     name: this.tabIndex,
      //     url: item.page
      // });
    },
    // 删除动态标签
    removeTab(targetName) {
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }

        this.editableTabsValue = activeName;
        this.editableTabs = tabs.filter(tab => tab.name !== targetName);
        sessionStorage.setItem("editableTabs",JSON.stringify(this.editableTabs));
    },
    handleClick(tab) {
      let obj = {}
        this.breadcrumbList = [{caidan:'首页',name:'/home'}]
        this.editableTabs.forEach((item,index)=>{
          if(Number(tab.index) == index){
            obj = item
            this.$router.push(item.url,()=>{}, ()=>{})
          }
        })
        this.navList.forEach((item,index)=>{
          item.child && item.child.forEach((val,i)=>{
            if(val.name == obj.title){
              this.breadcrumbList.push({caidan:item.name,name:item.page})
              this.secondIndexs = i
              this.activeIndexs = index
              this.menuItemData = item
            }
          })
        })
        // 导航栏切换
        if(obj.title != '首页'){
          this.breadcrumbList.push({caidan:obj.title,name:obj.url})
        }else{
          this.collapseactiveName = null
        }
        sessionStorage.setItem("editableTabs",JSON.stringify(this.editableTabs));
    },
    // 刷新
    refresh(){

    },
    close(){
      this.editableTabs = [],
      sessionStorage.removeItem('editableTabs');
      sessionStorage.removeItem('newTabName');
      this.breadcrumbList = [{caidan:'首页',name:'/home'}]
    },
    // 跳转个人信息
    personal(){
      this.$router.push('/my')
    },
    // 修改密码
    changePassword(){
      this.$router.push({path:'/my',query: {name:'third'}})
    },
    // 帮助中心
    helpCenter(){
      window.open('https://jxsaxnqa5o9.feishu.cn/wiki/KRQJwvNY7iVCS6kxH0SctFainAg')
    },
    // 退出登录
    logOut(){
      this.$router.push('/')
    //   if (window.location.hostname == 'b.ziyichain.cn') {
    //    window.location.href = 'https://shop.ziyichain.cn/login'
    //  }else {
    //   window.location.href = 'https://s.ziyichain.cn/login'
    //  }
      sessionStorage.removeItem('newTabName');
      sessionStorage.removeItem('editableTabs');
    },
    quit() {
      this.$router.replace({
        path: "/",
      });
      sessionStorage.clear();
      location.reload();
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {
      // if (key == this.$route.path) {
      //   this.$router.go(0)
      // }
      // this.$refs['pagefeed'].pagefeed()
      if (key == "/") {
        sessionStorage.clear();
        location.reload();
      }
    },
    setCurrentRoute() {
      this.defaultActive = this.$route.name; //关键   通过他就可以监听到当前路由状态并激活当前菜单
    },
    read() {
      let params = new URLSearchParams();
      params.append("ope_type", "未读数量");
      params.append("recv_user_name", sessionStorage.getItem("name"));
      params.append("recv_user_id", sessionStorage.getItem("user_id"));
      params.append("recv_user_type", "后台");
      this.$axios
        .get(messageshow, {
          params,
        })
        .then((res) => {
          this.NUM = res.data;
        });
    },
    pagefeed() {
      this.$axios
        .get(userlevelpages, {})
        .then((res) => {
          this.navList = res.data;
          this.breadcrumbList = [{caidan:'首页',name:'/home'}]
        this.navList.map((item,index)=>{
        item.child && item.child.map(val=>{
          if(this.$route.name == val.page){
            if(item.name != '快捷导航'){
              this.breadcrumbList.push({caidan:item.name,name:item.page})
              this.collapseactiveName = index
              this.breadcrumbList.push({caidan:val.name,name:val.page})
            }
          }
        })
      })
        });
    },
    PIM() {
      let params = new URLSearchParams();
      params.append("ope_type", "个人信息");
      params.append("user_id", sessionStorage.getItem("user_id"));
      this.$axios.post(userdata, params).then(async (res) => {
        this.PIMS = res.data;
        sessionStorage.setItem("department", res.data[0].department);
        await this.pagefeed();
      });
    },
    //获取页面配置信息
    basic() {
      let params = new URLSearchParams();
      params.append("page_size", "all");
      params.append("page_number", 1);
      params.append("companyid", sessionStorage.getItem("companyid"));
      this.$axios
        .get(allocation, {
          params,
        })
        .then((res) => {
          res.data[0]["pagedata"].forEach((e) => {
            if (e.name == "系统logo") {
              this.logo = e.message;
            }
            if (e.name == "首页展示图") {
              this.homebg = e.message;
            }
            if (e.name == "系统标题") {
              this.headline = e.message;
            }
          });
        });
    },
    urlData() {
        let par =[]
        let params = new URLSearchParams()
        params.append('ope_type', '目录')
        this.$axios.post(UserPage, params).then(res => {
          this.options=[]
          res.data.forEach(item => {
            item.oo=[]
            if (item.parent_id == 0) {
              this.options.push(item)
            }
          })
          this.options.forEach(e =>{
            res.data.forEach(item => {
              if(e.GZL_MENU_id_PK == item.parent_id){
               e.oo.push(item)
              }
            })
          })
        })
      },

  },
  mounted() {
    this.basic();
    this.navList = [];
    this.PIM();
    this.read();
    this.urlData()
    // if (!sessionStorage.getItem("password")) {
    //   this.$router.push("/");
    //   this.$route.go(0);
    // }
    var that = this;
    // 信息页面点击已读事件刷新 未读数量
    Utils.$on("demo", function (msg) {
      that.read();
    });

      if(!!JSON.parse(sessionStorage.getItem("editableTabs"))){
       this.editableTabs = JSON.parse(sessionStorage.getItem("editableTabs"))
      }
      if(!!sessionStorage.getItem("newTabName")){
        this.tabIndex = Number(JSON.parse(sessionStorage.getItem("newTabName")))
        this.editableTabsValue = JSON.parse(sessionStorage.getItem("newTabName"))
      }

  },
  computed: {},
  watch: {
    $route() {
      this.setCurrentRoute();
      Utils.$on("demo", function (msg) {
        this.read();
      });
    },
  },
  created() {
    this.setCurrentRoute();
    // location.reload()
  },
};
</script>

<style>
@import "../css/index.css";

#home {
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  /* display: flex;
    height: 100%;
    width: 100%; */
  margin: 0;
  padding: 0;
}

/* .left {
    width: 300px;
    height: 100%;
  } */

.right {
  flex: 1;
  height: 100%;
  /* background-color: #9dc3e6; */
}
.container{
  background-color: #fff;
  width: 100%;
  display: flex;
  margin-left: 5px;
  padding-left: 20px;
  border-bottom: 1px solid #e1e1e2;
}

.el-header,
.el-footer {
  height: 50px;
  overflow: hidden;
  /* position: relative; */
  background: #fff;
  /* -webkit-box-shadow: 0 1px 4px rgb(0 21 41 / 8%); */
  /* box-shadow: 0 1px 4px rgb(0 21 41 / 8%); */
  color: #606266;
}
.el-aside {
  width: auto !important;
  text-align: center;
  background: #fff;
}
/*::-webkit-scrollbar {*/
/*    display: none;*/
/*  }*/

.el-main {
  background-color: #e9eef3;
  color: #333;
  padding: 10px 0px 0 10px;
  padding-left: 5px;
  /* text-align: center; */
}

body > .el-container {
  margin-bottom: 2.5rem;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 16.25rem;
}

.el-container:nth-child(7) .el-aside {
  line-height: 20rem;
}

.el-collapse {
  border: none !important;
}

/*.el-menu-item {*/
/*  border-bottom: black 0.0625rem solid;*/
/*}*/

.el-menu-item,
.el-submenu__title {
  height: 48px;
  line-height: 53px;
  position: relative;
  -webkit-box-sizing: border-box;
  white-space: nowrap;
  list-style: none;
}
.tabsBox{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 5px;
  background: #e9eef3;

}
.tabs{
  /* width: 70%; */
}

.tabsContent{
  width: 100%;
  height: 44px;
  background-color: #fff;
  padding-top: 5px;
  padding-left: 5px;
  display: flex;
  align-items: center;

}

</style>
<style scoped>
.tabsContentMenu{

  /* background: #606266; */
}
.moreTbn{
  margin-left: 10px;
}
/deep/ .el-icon-bell {
  margin-right: 0 !important;
}
header span{
  color: #606266;
}
/deep/ .el-tabs__header{
  margin: 0;
}
/deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav{
  border: none;
  margin-left: 14px;
  margin-right: 20px;
}
/deep/ .el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
  /* border-bottom-color: #054d78; */
  color: #000;
  background: #e9eef3;
  font-weight: bold;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

}
/deep/ .el-tabs--card>.el-tabs__header .el-tabs__item.is-active::before{
    content: '';
    width: 20px;
    height: 20px;
    position: absolute;
    left: -17px;
    bottom: 0;
    background: radial-gradient(circle at 0 0, transparent 0 20px,#e9eef3 21px);
}
/deep/ .el-tabs--card>.el-tabs__header .el-tabs__item.is-active::after{
    content: '';
    width: 20px;
    height: 20px;
    position: absolute;
    right: -17px;
    bottom: 0;
    background: radial-gradient(circle at 100% 0, transparent 0 20px,#e9eef3 21px);
}
/deep/ .el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
  border-color: transparent;
}
/deep/ .el-tabs__item:hover{
  color: #000;
}
/deep/ .el-tabs--card>.el-tabs__header, /deep/ .el-tabs--card>.el-tabs__header .el-tabs__item{
  border: none !important;
}
/*去掉el-tab-pane底部灰色线条*/
/deep/ .deleteBorder .el-tabs__nav-wrap::after{
    height: 0;
  }
  /*去掉el-tab-pane切换时的蓝色下划线*/
/deep/ .deleteBorder .el-tabs__active-bar{
   background: transparent;
 }
 .leftTabs /deep/ .el-tabs__nav-wrap::after{
  position: static !important;
}
.leftTabs /deep/ .el-tabs__active-bar{
  background-color: transparent !important;

}
/deep/ .el-tabs--card>.el-tabs__header .el-tabs__item{
  border-left: none !important;
}
/deep/ .el-header{
  padding: 0px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/home.vue